function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2383 0.25H1.72656C1.32812 0.25 0.976562 0.402344 0.671875 0.707031C0.390625 0.988281 0.25 1.33984 0.25 1.76172V12.2383C0.25 12.6602 0.390625 13.0234 0.671875 13.3281C0.976562 13.6094 1.33984 13.75 1.76172 13.75H9.25L13.75 9.25V1.76172C13.75 1.33984 13.5977 0.988281 13.293 0.707031C13.0117 0.402344 12.6602 0.25 12.2383 0.25ZM3.23828 4.01172H10.7617V5.48828H3.23828V4.01172ZM7 8.51172H3.23828V7H7V8.51172ZM8.51172 12.625V8.51172H12.625L8.51172 12.625Z",
  fill: "currentColor"
});

var SvgStickyNote = function SvgStickyNote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStickyNote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sticky_note.aecf336a.svg";
export { ForwardRef as ReactComponent };